import { observer } from 'mobx-react-lite';

import { ComparingRigsChartDataModel } from '../../features/comparing-rigs-chart/data';
import { ComparingSummaryData } from '../../features/summary-data/view/comparing-summary-data';
import { SummaryViewProvider } from '../../shared/summary-view-provider';
import { Viewport } from '../../shared/viewport/viewport';

import { IRigSummary } from './entities/rig-summary';
import { SummaryDataSidebarWrapper } from './summary-data-sidebar-wrapper';

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
  data: (IRigSummary | null)[] | null;
  backgroundItems: ComparingRigsChartDataModel.ViewItem[] | null;
  viewport: Viewport;
  viewProvider: SummaryViewProvider;
  selectedYear: number;
  onYearChange(year: number): void;
  onScroll(offset: number): void;
  className?: string;
}

export const ComparingSummaryDataSidebar = observer(function ComparingSummaryDataSidebar({
  isOpen,
  className,
  backgroundItems,
  viewport,
  onClose,
  onScroll,
  data,
  viewProvider,
  selectedYear,
  onYearChange,
}: Props) {
  if (!isOpen) {
    return null;
  }

  return (
    <SummaryDataSidebarWrapper
      isOpen={isOpen}
      onClose={onClose}
      selectedYear={selectedYear}
      onYearChange={onYearChange}
      className={className}
    >
      <ComparingSummaryData
        data={data}
        backgroundItems={backgroundItems}
        viewProvider={viewProvider}
        onScroll={onScroll}
        viewport={viewport}
      />
    </SummaryDataSidebarWrapper>
  );
});
